export default [
  {
    path: '*',
    name: 'error-404',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  }, 
  {
    path: '/register',
    name: 'auth-register',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  }, 
  
  {
    path: '/pages/authentication/resetpassword',
    name: 'resetpassword',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/authentication/resetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
 
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/EmailVerification/:varifyId',
    name: 'EmailVerification',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/pages/authentication/EmailVerification.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/termsAndCondition',
    name: 'termsAndConditionDisplay',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/Setting/TermsAndConditionStaticPage.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicyDisplay',
    component: () => import(/* webpackChunkName: "[request]" */'@/views/Setting/PrivacyPolicyStatic.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
]
